import React from 'react'
import { useRecoilCallback, useRecoilValue, useResetRecoilState } from 'recoil'
import { useIntl } from 'react-intl'

import { ModalConfirm } from 'mailup-web-components'

import { modalConfirmResetState } from '../recoil/state/modals'
import { deletePlainTextCallback } from '../recoil/callbacks/callbacks'

const ModalConfirmReset = () => {
  const intl = useIntl()

  const { show } = useRecoilValue(modalConfirmResetState)
  const resetModal = useResetRecoilState(modalConfirmResetState)
  const resetPlainText = useRecoilCallback(deletePlainTextCallback, [])

  const handleCancel = () => {
    resetModal()
  }

  const handleConfirm = () => {
    resetModal()
    resetPlainText()
  }

  return (
    <ModalConfirm
      show={show}
      title={intl.formatMessage({
        id: 'Load.EmailCheckUp.PlainTextVersionCleanFieldModalTitle'
      })}
      message={intl.formatMessage({
        id: 'Load.EmailCheckUp.PlainTextVersionCleanFieldModalBody'
      })}
      stringConfirm={intl.formatMessage({
        id: 'Load.EmailCheckUp.PlainTextVersionCleanFieldModalCta'
      })}
      stringCancel={intl.formatMessage({
        id: 'Load.ModalConfermeDelete.Cancel'
      })}
      onClickCancel={handleCancel}
      onClickConfirm={handleConfirm}
      variant='delete'
      data-mu-test='modal-delete__reset-text-version'
    />
  )
}

export default ModalConfirmReset
